/**
 * Same build flag as `FirstVisitDownloadDialog` in `LanguageLayout`.
 * When not exactly `"true"`, the first-visit sheet is hidden and download-app
 * promotion links (welcome page, auth side panel) stay hidden as well.
 */
export function isShowFirstVisitDownloadDialogEnabled(): boolean {
  return process.env.REACT_APP_SHOW_FIRST_VISIT_DIALOG === "true";
}
